import { useEffect, useState } from "react";

const getFontSize = () =>
  Number.parseFloat(
    window
      .getComputedStyle(document.documentElement)
      .getPropertyValue("font-size")
      .match(/\d+/)?.[0] || "16",
  );

export const useBaseFontSize = () => {
  const [fontSize, setFontSize] = useState(() => getFontSize());

  useEffect(() => {
    const onResize = () => {
      setFontSize(getFontSize());
    };
    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, []);

  return fontSize;
};

export const useRemValue = (px: number) => {
  const fontSize = useBaseFontSize();

  return px * (fontSize / 16);
};
